<template>
  <div>
    <div slot="title">
      <h2>Asignar Evaluadores</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px">
          <div class="col-2">
            <router-link to="/SISEVA/DetallesEvaluado">
              <button type="button" class="form-control"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:3vw">Regresar</span></button>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="border-right:solid;padding-right:20px;">
            <div class="row">
              <div class="col-12"><h4><span class="col-form-label">Persona Evaluada</span></h4></div>
            </div>
            <div class="row" style="margin-top:30px;margin-bottom:10px;">
              <div class="col-12" style="overflow:hidden">
                <img src="https://concepto.de/wp-content/uploads/2018/08/persona-e1533759204552.jpg" class="thumb" />
              </div>
              <div class="col-12">
                <div class="row"><span class="col-form-label"><b>Evaluado : </b>José María Pérez Pérez</span></div>
                <div class="row"><span class="col-form-label"><b>Estatus : </b>Auto-evaluación no contestada</span></div>
                <div class="row"><span class="col-form-label"><b>Sección : </b>Nombre de la sección</span></div>
                <div class="row"><span class="col-form-label"><b>Departamento : </b>Nombre del dpto.</span></div>
                <div class="row"><span class="col-form-label"><b>Puesto : </b>Secretario Técnico</span></div>
                <div class="row"><span class="col-form-label"><b>Tipo Puesto : </b>Base</span></div>
                <div class="row"><span class="col-form-label"><b>Periodo a Evaluar : </b>01/01/2019 - 01/03/2019</span></div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="row">
              <ul class="nav nav-tabs" id="tabAsignarEvaluadores" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="personales-tab" data-toggle="tab" href="#evaluadores" role="tab" aria-controls="personales" aria-selected="true">Evaluadores</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="academicos-tab" data-toggle="tab" href="#buscarEvaluadores" role="tab" aria-controls="academicos" aria-selected="false">Buscar Evaluadores</a>
                </li>
              </ul>
            </div>
            <div class="row" style="margin-top:20px;min-height:30vh;">
              <div class="tab-content" id="myTabContent" style="display:flex;width:100%">
                <div class="tab-pane fade show active" id="evaluadores" role="tabpanel" aria-labelledby="personales-tab">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-4">
                        <h5><span class="col-form-label">Evaluadores</span></h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <span class="col-form-label">Superiores</span>
                      </div>
                      <div class="col-4">
                        <span class="col-form-label">Iguales</span>
                      </div>
                      <div class="col-4">
                        <span class="col-form-label">Subordinados</span>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px;">
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Puesto</option>
                          <option>Director de Informática</option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Puesto</option>
                          <option>Jefe de Dpto. de Desarrollo</option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Puesto</option>
                          <option>Auxiliar de Desarrollo</option>
                          <option>Auxiliar de Base de Datos</option>
                        </select>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px;">
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Nombre del Evaluador</option>
                          <option>Juan Manuel López Pérez</option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Nombre del Evaluador</option>
                          <option>América León</option>
                        </select>
                      </div>
                      <div class="col-4">
                        <select class="form-control">
                          <option selected disabled>Nombre del Evaluador</option>
                          <option>Manuel Gonzalez</option>
                          <option>Luis Sanchez</option>
                          <option>Héctor Bonilla</option>
                        </select>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px;">
                      <div class="col-2"></div><div class="col-2"><button type="button" class="form-control"><span class="col-form-label">Agregar</span><i class="fa fa-greater-than" style="margin-left:1vw"></i></button></div>
                      <div class="col-2"></div><div class="col-2"><button type="button" class="form-control"><span class="col-form-label">Agregar</span><i class="fa fa-greater-than" style="margin-left:1vw"></i></button></div>
                      <div class="col-2"></div><div class="col-2"><button type="button" class="form-control"><span class="col-form-label">Agregar</span><i class="fa fa-greater-than" style="margin-left:1vw"></i></button></div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="buscarEvaluadores" role="tabpanel" aria-labelledby="academicos-tab">
                  <div class="container-fluid">
                    <div class="row" style="margin-top:30px;">
                      <div class="col-3">
                        <input type="text" class="form-control" placeholder="Nombre" />
                      </div>
                      <div class="col-3">
                        <input type="text" class="form-control" placeholder="No. de Nómina" />
                      </div>
                      <div class="col-1">
                        <input type="checkbox" v-model="filtroPuesto" />
                      </div>
                      <div class="col-2">
                        <span class="label label-default">Tipo de Puesto</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-3"><hr /></div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-1" v-show="filtroPuesto">
                        <input type="checkbox" />
                      </div>
                      <div class="col-2" v-show="filtroPuesto">
                        <span class="label label-default">Interinato</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-1" v-show="filtroPuesto">
                        <input type="checkbox" />
                      </div>
                      <div class="col-2" v-show="filtroPuesto">
                        <span class="label label-default">Base</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-9"></div>
                      <div class="col-2"><input type="button" v-on:click="buscarEvaluadores" value="Buscar" class="form-control" /></div>
                    </div>
                    <div class="row" v-show="mostrarTabla" style="margin-top:20px;">
                      <div class="col-10">
                        <table class="table table-striped table-light table-hover" id="tablaBusqueda">
                          <thead class="thead-dark">
                            <tr>
                              <th>ID Persona</th>
                              <th>Nombre</th>
                              <th>Puesto</th>
                              <th>Tipo Evaluador</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="text-dark">
                            <tr>
                              <td>43</td>
                              <td>José María Elizalde</td>
                              <td>Asistente de Ejecutores</td>
                              <td><selectTipoEvaluador v-bind:agregarBoton="agregarBoton"></selectTipoEvaluador></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>51</td>
                              <td>José María Velarde</td>
                              <td>Asistente de Informática</td>
                              <td><selectTipoEvaluador v-bind:agregarBoton="agregarBoton"></selectTipoEvaluador></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>66</td>
                              <td>Juan José Sanchez</td>
                              <td>Director de Psicología</td>
                              <td><selectTipoEvaluador v-bind:agregarBoton="agregarBoton"></selectTipoEvaluador></td>
                              <td></td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <h5><span class="col-form-label">Evaluadores Seleccionados</span></h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaEvaluadores">
                  <thead class="thead-dark">
                    <tr>
                      <th>ID Persona</th>
                      <th>Nombre del Evaluador</th>
                      <th>Puesto</th>
                      <th>Tipo Evaluador</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    
                    

                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-10"></div>
              <div class="col-2">
                <router-link to="/SISEVA/DetallesEvaluado">
                  <input type="button" class="form-control" value="Guardar" v-bind:disabled="numeroFilas<=1" />
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue'
  export default {
    data() {
      return {
        filtroPuesto: false,
        mostrarTabla: false,
        numeroFilas: 1
      }
    },
    components: {
      selectTipoEvaluador: {
        props: ['agregarBoton'],
        template: "<select class='form-control' @change='agregarBoton'>" +
          "<option selected disabled value=0>Tipo de Evaluador</option>" +
          "<option value=1>Superior</option>" +
          "<option value=2>Igual</option>" +
          "<option value=3>Subordinado</option>" +
          "</select>"
      }
    },
    methods: {
      buscarEvaluadores: function (event) {
        this.mostrarTabla = true;
      },
      borrarFila: function (event) {
        var boton = event.target
        var row = boton.parentElement.parentElement;
        if (row.tagName == "TR") {
          row.remove();
          this.numeroFilas--;
        }
      },
      agregarBoton: function (event) {
        if (event.target.selectedIndex > 0) {
          var row = event.target.parentElement.parentElement;
          if (row.cells[row.cells.length - 1].children.length > 0) {
            return
          }
          var instancia = new Vue({
            template: "<i class='fa fa-plus-circle' @click='agregarFila'/>",
            methods: {
              agregarFila: this.agregarFila
            }
          })
          //console.log(instancia)
          instancia.$mount() // pass nothing
          row.cells[row.cells.length - 1].appendChild(instancia.$el)
        }

      },
      agregarFila: function (event) {
        var row = event.target.parentElement.parentElement;
        var select = row.cells[3].childNodes[0]
        row.cells[3].innerHTML = select.options[select.selectedIndex].text;
        var instancia = new Vue({
          template: "<i class='fa fa-trash' @click='borrarFila'/>",
          methods: {
            borrarFila: this.borrarFila
          }
        })
        $(row.cells[4].childNodes[0]).remove()
        instancia.$mount()
        row.cells[4].appendChild(instancia.$el)
        //alert(event.target.parentElement.parentElement.childNodes[0].innerHTML);
        $('#tablaEvaluadores').find('tbody:last').append($(row));
        this.numeroFilas++;
      }
    }
  }



  
</script>

<style scoped>
  td select {
    color: #504f54;
    background-color: transparent;
    border: solid;
    border-width: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/AsignarEvaluadores.vue